import storage from 'local-storage'


export default storage


if (process.env.NODE_ENV === 'development')
    window.storageX = storage
